module.exports = __webpack_public_path__ + "img/image167.3b4140c1.jpg";